











import { Vue, Component, PropSync } from 'vue-property-decorator'
import { Question, PhoneAnswer } from '../../controllers/Chat'

@Component
export default class PhoneAnswerComponent extends Vue {
    @PropSync('question', { required: true, type: Question })
    syncQuestion: Question

    // The errorState is set to false, everytime the user inputs something new, so they don't get confuse,
    // this is done with the Input event on v-text-field
    isValid: boolean = true

    onInput (formattedNumber, { number, valid, country }) {
      let phoneAnswer = this.syncQuestion.answer as PhoneAnswer
      phoneAnswer.value = number.international
      phoneAnswer.country = country && country.name
      this.isValid = valid
    }

    async addText () {
      let phoneAnswer = this.syncQuestion.answer as PhoneAnswer

      if (this.isValid) { // isValid
        this.$emit('validAnswer', phoneAnswer.value)
      } else {
        this.$emit('invalidAnswer', 'Opps looks, like the phone is not valid')
      }
    }
}
